import { Box, Typography } from '@mui/material';

import { DATE_FORMATS, formatDate } from '../../../utils/formatUtils';

const DATE_SX = { fontSize: 13, lineHeight: 1.3, whiteSpace: 'nowrap' };
const TIME_SX = {
  display: 'block',
  color: 'text.secondary',
  lineHeight: 1.3,
  whiteSpace: 'nowrap',
};

/**
 * Fecha y hora en dos líneas para celdas de tabla: la fecha (dd/mm/aaaa) arriba y la hora
 * (hh:mm) debajo en gris, para que la columna sea angosta y se lea completa.
 * @param {Object} props
 * @param {string|Date|null} props.value Fecha y hora a mostrar.
 * @param {string} [props.fallback] Texto cuando no hay fecha.
 * @param {string} [props.align] Alineación del texto (`left` o `right`).
 * @returns {JSX.Element}
 */
const DateTimeText = ({ value, fallback = '-', align = 'left' }) => {
  const date = formatDate(value, { fallback: '' });
  if (!date) {
    return (
      <Typography component="span" sx={DATE_SX}>
        {fallback}
      </Typography>
    );
  }
  const time = formatDate(value, { options: DATE_FORMATS.TIME_SHORT, fallback: '' });
  return (
    <Box component="span" sx={{ display: 'block', textAlign: align }} title={`${date} ${time}`}>
      <Typography component="span" sx={{ ...DATE_SX, display: 'block' }}>
        {date}
      </Typography>
      <Typography component="span" variant="caption" sx={TIME_SX}>
        {time}
      </Typography>
    </Box>
  );
};

export default DateTimeText;
